module.exports = {
  BorderRadius: { Sm: "3px", Md: "4px", Lg: "8px", Circle: "50%" },
};
